<template>
  <div class="home">
    <TopBar :itemLists="itemLists" />
    <div class="home-router">
      <router-view />
    </div>
      <!-- <Footer /> -->
  </div>
</template>
<script>

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  watch: {
    '$i18n.locale': function () {
    },
  },
  computed: {
    itemLists() {
      return [
        { name: this.$t('nav.Home'), routePath: '/' },
        { name: this.$t('nav.Attackwarn'), routePath: '/atteckWarn' },
        { name: this.$t('nav.Product'), routePath: '/products' },
        { name: this.$t('nav.DomainNames'), routePath: '/allDomain' },
        { name: this.$t('nav.Certmanage'), routePath: '/certManage' },
        {name: this.$t('nav.googleCheck'), routePath: '/googleCheck'},
        // { name: this.$t('nav.HandleLog'), routePath: '/handleLog' },
        { name: this.$t('nav.LoginLog'), routePath: '/loginLog' },
      ];
    },
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
  .home {
    background-color: #F5F6FA;
    position: relative;
    .home-router {
     min-height: 65vh;
     padding-top: 60px;
    }
  }
</style>
